import React, { useState } from "react";
import "./Portfolio.css";
import { motion } from "framer-motion";
import { projectCard } from "../../animations";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaAppStoreIos } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import ProjectDrawer from "./ProjectDrawer";

const ProjectCard = ({ project }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <motion.article className="portfolio__item" variants={projectCard}>
        <div className="portfolio__item-image">
          <img src={project.image} alt={project.title} />
        </div>

        <div className="portfolio__item-content">
          <h3>{project.title}</h3>
          <p className="portfolio__item-subtitle">{project.subtitle}</p>

          <div className="portfolio__item-cta">
            {project.playStore && (
              <a
                href={project.playStore}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                <IoLogoGooglePlaystore size={16} />
              </a>
            )}

            {project.appStore && (
              <a
                href={project.appStore}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                <FaAppStoreIos size={16} />
              </a>
            )}

            {project.link && (
              <a href={project.link} className="btn btn-primary" target="_blank" rel="noreferrer">
                <FiExternalLink size={16} />
              </a>
            )}

            <button className="btn" onClick={openDrawer}>
              See Details
            </button>
          </div>
        </div>
      </motion.article>

      <ProjectDrawer isOpen={isDrawerOpen} onClose={closeDrawer} project={project} />
    </>
  );
};

export default ProjectCard;
